import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_doc_item_export_file_hdr_RowClass} from '../../../dbschema';

export class DocItemExportFileContainerModel extends BaseContainerModel {
    bl_fi_doc_item_export_file_hdr: bl_fi_doc_item_export_file_hdr_RowClass = new bl_fi_doc_item_export_file_hdr_RowClass();
}